export const getRadioLabel = (label) => {
  return typeof label === 'string' ? label.trim() : label;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Radio/utils/radioHelpers.js